import * as React from 'react';
import './styles.scss';

export type ListProps = {
  list: { [id: string]: JSX.Element };
  direction?: "vertical" | "horizontal"
};

export const List: React.FunctionComponent<ListProps> = ({
  list,
  direction
}: ListProps) => {

  return (
    <ul className={`cmp-list cmp-list__${direction ?? "vertical"}`}>
      {Object.keys(list).map((key: string) => (
        <li key={key}>{list[key]}</li>
      ))}
    </ul>
  );
};
